
module.exports = {
  HOLD          : "h",
  IMMEDIATE     : "i",
  INDETERMINATE : "?",
  WHITE         : "w",
  RED           : "r",
  BLUE          : "b",
  BLACK         : "k",
  YELLOW        : "y",
  GREEN         : "g",
  YES           : "y",
  NO            : "n",
};



/** WEBPACK FOOTER **
 ** ./lib/constants.js
 **/